import React, { useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@/navigation/RootNavigator';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

type PdfRouteProp = RouteProp<RootStackParamList, 'PdfScreen'>;

export const PdfScreen: React.FC = () => {
  const route = useRoute<PdfRouteProp>();
  const navigation = useNavigation();
  const { semantic } = useThemeColors();
  const { url, title } = route.params;

  useLayoutEffect(() => {
    navigation.setOptions({ title });
  }, [navigation, title]);

  return (
    <View style={[styles.container, { backgroundColor: semantic.background.primary }]}>
      {React.createElement('iframe' as any, {
        src: url,
        title,
        style: { flex: 1, border: 0, width: '100%', height: '100%' },
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
});
